module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "修改登录密码"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "password-box"
  }, [_c('div', {
    staticClass: "flex space-between vux-1px-b"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.old),
      expression: "old"
    }],
    staticClass: "flex-1",
    attrs: {
      "type": "password",
      "placeholder": "请输入原密码"
    },
    domProps: {
      "value": (_vm.old)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.old = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.old.length > 0),
      expression: "old.length>0"
    }],
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": function($event) {
        _vm.old = ''
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex space-between vux-1px-b"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new1),
      expression: "new1"
    }],
    staticClass: "flex-1",
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    },
    domProps: {
      "value": (_vm.new1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.new1.length > 0),
      expression: "new1.length>0"
    }],
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": function($event) {
        _vm.new1 = ''
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex space-between vux-1px-b"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new2),
      expression: "new2"
    }],
    staticClass: "flex-1",
    attrs: {
      "type": "password",
      "placeholder": "请再次输入新密码"
    },
    domProps: {
      "value": (_vm.new2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.new2.length > 0),
      expression: "new2.length>0"
    }],
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": function($event) {
        _vm.new2 = ''
      }
    }
  })])]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.sbmt(_vm.old, _vm.new1, _vm.new2)
      }
    }
  }, [_vm._v("确定")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c4caa1f"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/changPassword/changPassword.vue
// module id = 537
// module chunks = 0